import {
  LOGIN,
  LOGOUT,
  SIGNUP,
  PASSWORD_RESET_INIT,
  PASSWORD_RESET_FINISH,
  CHANGE_PASSWORD,
  SEND_ONBOARDING_EMAIL
} from "./types";
import * as authApi from "@/api-client/auth";
import { updateUser } from "@/api-client/user";

export default {
  async login({ commit }, { data, onSuccess, onError }) {
    commit({
      type: LOGIN.request
    });

    try {
      const resp = await authApi.login(data);
      commit({
        type: LOGIN.success,
        payload: resp
      });

      onSuccess ? onSuccess(resp) : null;
    } catch (e) {
      commit({
        type: LOGIN.error,
        error: "ERROR!"
      });
      onError ? onError(e) : null;
    }
  },

  async logout({ commit }, cb) {
    commit({
      type: LOGOUT.request
    });
    try {
      await authApi.logout();
      commit({
        type: LOGOUT.success
      });
      commit(
        {
          type: `account/${LOGOUT.success}`
        },
        { root: true }
      );

      cb ? cb() : null;
    } catch (e) {
      commit({
        type: LOGOUT.error,
        payload: e.message
      });
    }
  },

  async signUp({ commit }, { data, onSuccess, onError }) {
    commit({
      type: SIGNUP.request
    });

    try {
      const resp = await authApi.signUp(data);

      commit({
        type: SIGNUP.success,
        payload: resp
      });

      onSuccess ? onSuccess(resp) : null;
    } catch (e) {
      commit({
        type: SIGNUP.error,
        payload: e.message
      });
      onError ? onError(e) : null;
    }
  },

  async resetPasswordInit({ commit }, { data, cb }) {
    commit({
      type: PASSWORD_RESET_INIT.request
    });

    try {
      await authApi.requestPasswordReset(data);

      commit({
        type: PASSWORD_RESET_INIT.success
      });

      cb ? cb() : null;
    } catch (e) {
      commit({
        type: PASSWORD_RESET_INIT.error,
        payload: e.message
      });
    }
  },

  async resetPasswordFinish({ commit }, { token, data, onSuccess, onError }) {
    commit({
      type: PASSWORD_RESET_FINISH.request
    });

    try {
      await authApi.finishPasswordReset(token, data);

      commit({
        type: PASSWORD_RESET_FINISH.success
      });

      onSuccess ? onSuccess() : null;
    } catch (e) {
      commit({
        type: PASSWORD_RESET_INIT.error,
        payload: e.message
      });

      onError ? onError(e.message) : null;
    }
  },

  async changePassword({ commit }, { values, cb, onError }) {
    commit({
      type: CHANGE_PASSWORD.request
    });
    try {
      await updateUser(values);
      commit({
        type: CHANGE_PASSWORD.success
      });
      cb ? cb() : null;
    } catch (e) {
      commit({
        type: CHANGE_PASSWORD.error,
        payload: e.message
      });
      onError ? onError(e.message) : null;
    }
  },

  async sendOnboardingEmail({ commit }, { data, onSuccess, onError }) {
    commit({
      type: SEND_ONBOARDING_EMAIL.request
    });

    try {
      await authApi.sendOnboardingEmail(data);

      commit({
        type: SEND_ONBOARDING_EMAIL.success
      });
      onSuccess ? onSuccess() : null;
    } catch (e) {
      commit({
        type: SEND_ONBOARDING_EMAIL.error,
        payload: e.message
      });

      onError ? onError(e.message) : null;
    }
  }
};
